<template>
	<div v-if="loading">
	</div>
	<div v-else>
		<vx-card title="Notificatie instellingen">
			<template lang="html">
				<div>
					<vs-table :data="notifications">
						<template slot="thead">
							<vs-th>
								Melding
							</vs-th>
							<vs-th>
								Email
							</vs-th>
							<vs-th>
								Telegram
							</vs-th>
						</template>
						<template>
							<vs-tr>
								<vs-td>
									Nieuwe bestelling
								</vs-td>
								<vs-td>
									<vs-checkbox class="check checkboxes" v-model="notifications[0].email"></vs-checkbox>
								</vs-td>
								<vs-td>
									<vs-checkbox :disabled="!telegramCoupled" class="check checkboxes"
												 v-model="notifications[0].telegram"></vs-checkbox>
								</vs-td>
							</vs-tr>
							<vs-tr>
								<vs-td>
									Lage product voorraad
								</vs-td>
								<vs-td>
									<vs-checkbox class="check checkboxes" v-model="notifications[1].email"></vs-checkbox>
								</vs-td>
								<vs-td>
									<vs-checkbox :disabled="!telegramCoupled" class="check checkboxes"
												 v-model="notifications[1].telegram"></vs-checkbox>
								</vs-td>
							</vs-tr>
							<vs-tr>
								<vs-td>
									Lage verpakkings voorraad
								</vs-td>
								<vs-td>
									<vs-checkbox class="check checkboxes" v-model="notifications[2].email"></vs-checkbox>
								</vs-td>
								<vs-td>
									<vs-checkbox :disabled="!telegramCoupled" class="check checkboxes"
												 v-model="notifications[2].telegram"></vs-checkbox>
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
					<div class="w-full vx-row btn-submit">
						<vs-button @click.native="update" class="btn-submit" color="primary" type="filled">Notificatie opties opslaan</vs-button>
					</div>
				</div>
			</template>
		</vx-card>
		<br />
		<vx-card title="Telegram instellingen">
			<template slot="actions">
				<vx-tooltip class="flex" text="Hoe en wat?">
					<font-awesome-icon icon="question-circle" @click="wiki"></font-awesome-icon>
				</vx-tooltip>
			</template>
			<div class="w-full vx-row">
				<div class="vx-col w-full">
					<label>
						Als je koppelt met Telegram kunnen we je ten alle tijden op de hoogte houden van bestellingen, voorraad, retouren, ect.<br />
						Je kunt koppelen via <a href="http://t.me/boldashboardnl_bot" target="_blank">hier</a> . Type '/start' naar de piqwisebot
						en hij zal
						je opweg helpen.
					</label><br /><br />
				</div>
				<div class="vx-col w-full">
					<label>
						<b>Telegram koppelcode:</b> {{ coupleCode.coupleCode }}
					</label><br /><br />
				</div>
				<div class="vx-col w-full">
					<div v-if="coupledUser === true">
						<b>Je account is al gekoppeld met de volgende telegram gebruikers:</b>
						<div class="w-full vx-row" v-for="singleUser in coupleCode.coupledUsers" :key="singleUser.date"
							 v-if="singleUser.type === 'private'">
							<div class="vx-col w-full">
								{{ singleUser.first_name }}&nbsp;{{ singleUser.last_name }}&nbsp;({{ singleUser.username }}) op
								{{ singleUser.date.slice(0, 10) }}&nbsp;{{ singleUser.date.slice(11, 19) }}
							</div>
						</div>
						<br />
					</div>
					<div v-if="coupledGroup === true">
						<b>Je account is al gekoppeld met de volgende telegram groepen:</b>
						<div class="w-full vx-row" v-for="group in coupleCode.coupledUsers" :key="group.date"
							 v-if="group.type === 'supergroup'">
							<div class="vx-col w-full">
								{{ group.group_title }} gekoppeld door {{ group.first_name }}&nbsp;{{ group.last_name }}&nbsp;({{ group.username }})
								op
								{{ group.date.slice(0, 10) }}&nbsp;{{ group.date.slice(11, 19) }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</vx-card>
	</div>
</template>

<script>
export default {
	name: 'settings-notifications',
	data() {
		return {
			coupledGroup: false,
			coupledUser: false,
			loading: true,
			telegramCoupled: false,
			coupleCode: '',
			notifications: [],
		}
	},
	mounted() {
		this.openLoading();
	},
	methods: {
		openLoading() {
			this.$vs.loading();
			this.$store.dispatch('NotificationsSettings/init').then(res => {
				const notifications = this.$store.state.NotificationsSettings.notifications;
				for (const index in notifications) {
					const notification = {...notifications[index]};
					this.notifications.push(notification);
				}
				this.telegramGet();
				this.$vs.loading.close();
				this.loading = false;
			})
		},
		update() {
			this.$store.dispatch('NotificationsSettings/updateNotificationsSettings', this.notifications['0']);
			this.$store.dispatch('NotificationsSettings/updateNotificationsSettings', this.notifications['1']);
			this.$store.dispatch('NotificationsSettings/updateNotificationsSettings', this.notifications['2'])
				.then(res => {
					this.createNotifySuccess();
				})
				.catch(err => {
					this.createNotifyFailed();
				});
		},
		telegramGet() {
			this.$store.dispatch('NotificationsSettings/getTelegram').then(res => {
				this.coupleCode = this.$store.state.NotificationsSettings.telegram;
				this.checkTelegramCoupled();
				this.connectedTelegram = this.$store.state.NotificationsSettings.telegram.coupledUsers.length;
				if (this.connectedTelegram > 0) {
					this.telegramCoupled = true;
				}
			})
		},
		checkTelegramCoupled() {
			for (let i = 0; i < this.coupleCode.coupledUsers.length; i++) {
				if (this.coupleCode.coupledUsers[i].type === 'private') {
					this.coupledUser = true;
				}

				if (this.coupleCode.coupledUsers[i].type === 'supergroup') {
					this.coupledGroup = true;
				}
			}
		},
		createNotifySuccess() {
			this.$vs.notify({
				color: 'success',
				title: 'Wijzigingen zijn opgeslagen',
				text: 'Je gegevens zijn verwerkt.',
			});
		},
		createNotifyFailed() {
			this.$vs.notify({
				color: 'danger',
				title: 'Gegevens zijn niet opgeslagen',
				text: 'Er is iets fout gegaan.',
			});
		},
		wiki() {
			window.open(this.$store.state.wiki.wiki.telegram)
		}
	}
}
</script>

<style scoped>
.checkboxes {
	width: 25px;
}

.btn-submit {
	padding-left: 15px;
}
</style>
